module.exports = __webpack_public_path__ + "static/media/completeditmate.d6a8d1e7.jpg";